export default class Column {
	constructor(section, df) {
		if (!df) df = {};

		this.df = df;
		this.section = section;
		this.section.columns.push(this);
		this.fields = [];
		this.make();
		this.resize_all_columns();
	}

	make() {
		this.wrapper = $(`
			<div class="form-column" data-fieldname="${this.df.fieldname}">
				<form>
				</form>
			</div>
		`).appendTo(this.section.body);

		this.wrapper.get(0).columnobj = this; // Store reference to Column object

		this.form = this.wrapper.find("form").on("submit", () => false);

		if (this.df.description) {
			$(`
				<p class="col-sm-12 form-column-description">
					${__(this.df.description, null, this.df.parent)}
				</p>
			`).prependTo(this.wrapper);
		}

		if (this.df.label) {
			$(`
				<label class="column-label">
					${__(this.df.label, null, this.df.parent)}
				</label>
			`).prependTo(this.wrapper);
		}
	}

	resize_all_columns() {
		// distribute visible columns equally, scoped to this section's direct children only
		let all_columns = this.section.body.children(".form-column");
		let visible_columns = all_columns.filter(":not(.hide-control)");
		let columns = visible_columns.length || all_columns.length;
		let col_classes = this.get_column_classes(columns);

		all_columns.each(function () {
			const $col = $(this);
			const is_hidden = $col.hasClass("hide-control");

			$col.removeClass(function (i, className) {
				return (className.match(/(^|\s)col-\S+/g) || []).join(" ");
			})
				.addClass("form-column px-sm-1")
				.addClass(col_classes);

			if (is_hidden) {
				$col.addClass("hide-control");
			}
		});
	}

	add_field() {}

	get_column_classes(actual_columns) {
		const section_df = this.section.df || {};
		const is_grid = section_df.layout_mode === "Grid";
		let responsive_config = section_df.responsive_columns;

		if (typeof responsive_config === "string") {
			try {
				responsive_config = JSON.parse(responsive_config);
			} catch (e) {
				responsive_config = null;
			}
		}

		// 1. If responsive_columns is explicitly provided as an object with keys
		if (responsive_config && typeof responsive_config === "object" && Object.keys(responsive_config).length > 0) {
			let classes = [];
			Object.keys(responsive_config).forEach((bp) => {
				let cols = cint(responsive_config[bp]);
				if (!cols) return;

				let colspan = cols == 5 ? 20 : cint(12 / cols);
				classes.push(`col-${bp}-${colspan}`);
			});

			if (classes.length > 0) {
				return classes.join(" ");
			}
		}

		// 2. Fallback when responsive_columns is not defined
		let columns;
		if (is_grid) {
			columns = Math.max(1, Math.min(6, cint(section_df.grid_columns) || 4));
		} else {
			columns = actual_columns || 1;
		}

		let colspan = cint(12 / columns);
		if (columns == 5) {
			colspan = 20;
		}

		return `col-sm-${colspan}`;
	}

	refresh() {
		if (!this.df) return;
		const hide = this.df.hidden || this.df.hidden_due_to_dependency;

		this.wrapper.toggleClass("hide-control", !!hide);
		this.resize_all_columns();
		this.section.refresh();
	}
}
